export enum EnStockStatus {
    EmEstoque = "EmEstoque",
    Critico = "Critico",
    Comprar = "Comprar",
    Pedido = "Pedido",
    None = "None",
    Status = "Status"
}
